import React from 'react'
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";

const Obligor = ({obligor}) => {
  return (
    <div className="my-12">
    <h2 className=" uppercase letter-spacing font-semibold text-gray-800 mt-5">
      Obligor Risk Rating{" "}
    </h2>
    <hr />
    <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4">
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          ORR Declined
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {obligor?.orrDeclined ? "Yes" : "No"}
          </p>
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Preliminary Score
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {obligor?.preliminaryScore }
          </p>
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Score Percentage
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {obligor?.totalScorePercentage }
          </p>
        </div>
      </div>
    </div>
    <div className="mt-8 flex flex-col">
      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table className="min-w-full table-fixed divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                  >
                    Description
                  </th>
                  <th
                    scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                  >
                    Value
                  </th>
                  <th
                    scope="col"
                    className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                  >
                    Score
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Monthly Income
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.monthlyIncome !== null ? FormatMoney(obligor?.monthlyIncome?.value) : " " }
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.monthlyIncome !== null ? obligor?.monthlyIncome?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Legal Action
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.legalAction != null ? (obligor?.legalAction?.value === true ? "Yes" : "No") : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.legalAction != null ? obligor?.legalAction?.score : "" }
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Amount Written Off
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.amountWrittenOff != null ? (obligor?.amountWrittenOff?.value === true ? "Yes" : "No") : " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.amountWrittenOff != null ? obligor?.amountWrittenOff?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Dishonored Cheque
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.dishonoredCheque != null ? (obligor?.dishonoredCheque?.value === true ? "Yes" : "No") : " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.dishonoredCheque != null ? obligor?.dishonoredCheque?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Non Performing Loans
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.nonPerformingLoans != null ? (obligor?.nonPerformingLoans?.value === true ? "Yes" : "No") : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.nonPerformingLoans != null ? obligor?.nonPerformingLoans?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Age
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.age != null ? obligor?.age?.value : " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.age != null ? obligor?.age?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    BVN Date
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.bvnRegistrationDate != null ? formatDate(obligor?.bvnRegistrationDate?.value)  : " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {/* {obligor?.bvnRegistrationDate ? " True" : false} */}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    BVN WatchListed
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.bvnWatchListed != null ? obligor?.bvnWatchListed?.value : " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.bvnWatchListed != null ? obligor?.bvnWatchListed?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Open Accounts{" "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.openAccounts != null ? obligor?.openAccounts?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.openAccounts != null ? obligor?.openAccounts?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Closed Accounts
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.closedAccounts != null ? obligor?.closedAccounts?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.closedAccounts != null ? obligor?.closedAccounts?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    First Loan Date
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.firstLoanDate != null ? formatDate(obligor?.firstLoanDate?.value): " "}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.firstLoanDate != null ? obligor?.firstLoanDate?.score : " "}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Accomodation Type
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.accomodationType != null ? obligor?.accomodationType?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.accomodationType != null ? obligor?.accomodationType?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Marital Status
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.maritalStatus != null ? obligor?.maritalStatus?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.maritalStatus != null ? obligor?.maritalStatus?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Dependants
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.dependants != null ? obligor?.dependants?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.dependants != null ? obligor?.dependants?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Gender
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.gender != null ? obligor?.gender?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.gender != null ? obligor?.gender?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Number Of Job Changes
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.numberOfJobChanges != null ? obligor?.numberOfJobChanges?.value : ""}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.numberOfJobChanges != null ? obligor?.numberOfJobChanges?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    State Of Residence
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    <span>
                      {" "}
                      {
                        obligor?.stateOfResidence != null ? obligor?.stateOfResidence?.value.currentState : ""
                      }{" "}
                      |{" "}
                      {
                        obligor?.stateOfResidence != null ? (obligor?.stateOfResidence?.value.isBvnStateOfResidence ? "BVN state of residence": "Not BVN state of residence") : ""
                      }{" "}
                      
                    </span>
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.stateOfResidence != null ? obligor?.stateOfResidence?.score : ""}
                  </td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    Contactability
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    <span>
                      {
                        obligor?.contactability != null ? obligor?.contactability?.value.currentPhoneNumber : ""
                      }{" "}
                      (Phone)
                    </span>
                    <span>
                      {" "}
                      |{" "}
                      {
                        obligor?.contactability != null ?  obligor?.contactability?.value.bvnPhoneNumber  : ""
                      }{" "}
                      (BVN)
                    </span>
                    <span>
                      {" "}
                      |{" "}
                      {
                        obligor?.contactability != null ? obligor?.contactability?.value.creditBureauPhoneNumber: ""
                      }{" "}
                      (Credit Bureau){" "}
                    </span>
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {obligor?.contactability != null ? obligor?.contactability?.score  : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Obligor
